import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { useNavigate } from "react-router-dom";
import fire from "../../config/Fire";
import { useAuth, roleHome } from "../../auth/AuthProvider";

/**
 * Public/legacy top nav, cleaned up per the redesign audit (§1.1/§3.3):
 * - Login navigates to the rebuilt /login PAGE (the modal twin is gone)
 * - Login and Logout are auth-aware — never shown together
 * - Dead items (Quote, Resources) removed; one role-aware Dashboard link
 *   replaces the Agent/Client pair that bounced users to the wrong place
 * The full public-header rebuild is Phase 4; this only removes the traps.
 */
function FawnNav() {
  const { user, role } = useAuth();
  const navigate = useNavigate();

  const logOut = async (e) => {
    e.preventDefault();
    await fire.auth().signOut();
    navigate("/");
  };

  return (
    <div className="item-shadow">
      <Navbar bg="light" expand="lg" style={{ width: "100%", padding: "1px", color: "white" }}>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Brand href="/">
          <strong>F A W N | Insurance</strong>
        </Navbar.Brand>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link onClick={() => navigate("/")}>
              <div className="nav-div">
                <strong>Home</strong>
              </div>
            </Nav.Link>

            {user && role ? (
              <Nav.Link onClick={() => navigate(roleHome(role))}>
                <div className="nav-div">
                  <strong>Dashboard</strong>
                </div>
              </Nav.Link>
            ) : null}

            {user ? (
              <Nav.Link onClick={logOut}>
                <div className="nav-div">
                  <strong>Logout</strong>
                </div>
              </Nav.Link>
            ) : (
              <Nav.Link onClick={() => navigate("/login")}>
                <div className="nav-div">
                  <strong>Login</strong>
                </div>
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default FawnNav;
